import { createContext, useContext } from 'react';

import type { PageData } from 'bundles/promo-template/queries/hooks/useEmbeddedPageContentQuery';

export type EmbeddedPromoTemplatePageContextType = {
  page?: PageData;
};

const EmbeddedPromoTemplatePageContext = createContext<EmbeddedPromoTemplatePageContextType>({
  page: undefined,
});

export const useEmbeddedPromoTemplatePage = () => useContext(EmbeddedPromoTemplatePageContext);

export default EmbeddedPromoTemplatePageContext;
